import queryClient from "api/queryClient.ts";
import { getOfferQueryOptions } from "api/TenantSlug/Offer/queryOptions.ts";
import { PingTreeReportDetailReport } from "components/Report/PingTreeReport/PingTreeReportDetailReport.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getReportHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/report/_layout/pingtree/_layout/$pingtreeId/"
)({
    component: PingTreeReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportCascadeView],
        showInSideMenu: false,
        label: "pages.report.pingtree.detail.title",
    },
    loader: async ({ params }: { params: { pingtreeId: string } }) => {
        let breadcrumb = params.pingtreeId;

        try {
            const { offer } = await queryClient.ensureQueryData(
                getOfferQueryOptions(params.pingtreeId, {})
            );

            breadcrumb = offer?.visible_title || breadcrumb;
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
        };
    },
});

function PingTreeReportPage() {
    const { pingtreeId } = Route.useParams();

    return (
        <TenantPage headerNavigationItems={getReportHeaderItems}>
            <PingTreeReportDetailReport cascadeId={pingtreeId} />
        </TenantPage>
    );
}
